export const COMPANY_NAME = 'Amplify Life';
export const WRITING_AGENT_NAME = 'Korinne Vegvary';
export const MIN_COVERAGE_AMOUNT = 50000;
export const MIN_PREMIUM_AMOUNT = 65;
export const PROSPER_MAX_AGE_LIMIT = 60;
export const PROSPER_MIN_AGE_LIMIT = 18;
export const MAX_RATE_OF_RETURN =
    process.env.NEXT_PUBLIC_SST_STAGE === 'prod' || process.env.NEXT_PUBLIC_SST_STAGE === 'preprod' ? 5.79 : 100;
export const PROSPER_DEFAULT_RATE_OF_RETURN = 5.79;
export const DISTRIBUTION_START_AGE = 66;
export const DISTRIBUTION_END_AGE = 85;

// HHI (Household Income) validation thresholds for Prosper IUL
export const HHI_THRESHOLDS = {
    AGE_1_30: 2860, // Min HHI for ages 1-30  (100k ÷ 35x)
    AGE_31_40: 3333, // Min HHI for ages 31-40 (100k ÷ 30x)
    AGE_41_50: 4000, // Min HHI for ages 41-50 (100k ÷ 25x)
    AGE_51_60: 5000, // Min HHI for ages 51-60 (100k ÷ 20x)
    AGE_61_65: 6667, // Min HHI for ages 61-65 (100k ÷ 15x)
    AGE_66_PLUS: 20000, // Min HHI for ages 66+    (100k ÷ 5x)
} as const;

export const MIN_COVERAGE_AMOUNT_FOR_HHI = 50000; // $50k minimum coverage

/**
 * Validates if household income meets minimum requirements for Prosper IUL based on age
 * @param age - Applicant's age
 * @param householdIncome - Annual household income
 * @returns Object with isValid boolean and required minimum income
 */
export const validateHouseholdIncome = (age: number, householdIncome: number) => {
    let requiredMinIncome: number;

    if (age >= 66) {
        requiredMinIncome = HHI_THRESHOLDS.AGE_66_PLUS;
    } else if (age >= 61) {
        requiredMinIncome = HHI_THRESHOLDS.AGE_61_65;
    } else if (age >= 51) {
        requiredMinIncome = HHI_THRESHOLDS.AGE_51_60;
    } else if (age >= 41) {
        requiredMinIncome = HHI_THRESHOLDS.AGE_41_50;
    } else if (age >= 31) {
        requiredMinIncome = HHI_THRESHOLDS.AGE_31_40;
    } else {
        requiredMinIncome = HHI_THRESHOLDS.AGE_1_30;
    }

    return {
        isValid: householdIncome >= requiredMinIncome,
        requiredMinIncome,
    };
};

/**
 * Validates if prosper illustration is valid
 * @param monthlyPremium - Monthly premium
 * @param faceAmount - Face amount
 * @param lapseAge - Lapse age
 * @param quoteAge - Current age submitted in quote
 * @returns boolean
 */
export const validateIllustration = (
    monthlyPremium: number,
    faceAmount: number,
    lapseAge: number,
    quoteAge: number,
) => {
    // the premium needs to be at least $65/mo, initial death benefit >= $50k, the cash value at year 15 needs to exist and not be 0, and the lapse age is at least 15 years after the quote age
    return monthlyPremium >= MIN_PREMIUM_AMOUNT && faceAmount >= MIN_COVERAGE_AMOUNT && lapseAge - quoteAge >= 15;
};
